// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stakeholder-section {
  padding: 6rem 0;
}
.stakeholder-section .stakeholders-update-btn-container {
  position: relative;
}
.stakeholder-section .stakeholders-update-btn-container .add-btn {
  position: absolute;
  right: 1rem;
  top: 30px;
}

.stakeholders-update-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 2rem;
  min-height: 55vh;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.stakeholders-update-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.stakeholders-update-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.stakeholders-update-section .custom-container .content-body {
  margin: 3rem auto 0;
  max-width: 1200px;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card {
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  height: 330px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  transition: 0.4s;
  max-width: 280px;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-header {
  background: #d0dbff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-header .image-uploader {
  position: absolute;
  top: 3px;
  right: 4px;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-header .image-uploader .icon-update-btn {
  height: 40px;
  width: 40px;
  background: #b4b4b4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  transition: 0.4s;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-header .image-uploader .icon-update-btn .fa-pencil {
  font-size: 18px;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-header .image-uploader .icon-update-btn:hover {
  background: gray;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-header img {
  width: 90%;
  height: 130px;
  object-fit: contain;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-body {
  height: calc(100px - 1rem);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-body .stakeholder-organization {
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
}
.stakeholders-update-section .custom-container .content-body .stakeholder-card .card-footer {
  background: transparent;
  border-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/home/stakeholders.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AADN;;AAUI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AAPN;AASM;EACE,iBCdK;EDeL,kBAAA;EACA,cAAA;AAPR;AASQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAPV;AAYI;EACE,mBAAA;EACA,iBAAA;AAVN;AAYM;EACE,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAVR;AAYQ;EACE,mBCzDS;ED0DT,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAVV;AAYU;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAVZ;AAYY;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAVd;AAYc;EACE,eAAA;AAVhB;AAac;EACE,gBAAA;AAXhB;AAgBU;EACE,UAAA;EACA,aAAA;EACA,mBAAA;AAdZ;AAmBQ;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;AAjBV;AAmBU;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AAjBZ;AAqBQ;EACE,uBAAA;EACA,aAAA;AAnBV","sourcesContent":["@import \"../../../../assets/css/common/variables\";\r\n\r\n.stakeholder-section {\r\n  padding: 6rem 0;\r\n\r\n  .stakeholders-update-btn-container {\r\n    position: relative;\r\n\r\n    .add-btn {\r\n      position: absolute;\r\n      right: 1rem;\r\n      top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n.stakeholders-update-section {\r\n\r\n  .custom-container {\r\n\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 2rem;\r\n      min-height: 55vh;\r\n      font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .content-body {\r\n      margin: 3rem auto 0;\r\n      max-width: 1200px;\r\n\r\n      .stakeholder-card {\r\n        background: #fff;\r\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n        border-radius: 12px;\r\n        height: 330px;\r\n        padding: 1rem;\r\n        margin-bottom: 1.5rem;\r\n        transition: .4s;\r\n        max-width: 280px;\r\n\r\n        .card-header {\r\n          background: $color-blue-light;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n          height: 150px;\r\n          border-radius: 12px;\r\n          overflow: hidden;\r\n          position: relative;\r\n\r\n          .image-uploader {\r\n            position: absolute;\r\n            top: 3px;\r\n            right: 4px;\r\n\r\n            .icon-update-btn {\r\n              height: 40px;\r\n              width: 40px;\r\n              background: #b4b4b4;\r\n              color: #fff;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              border-radius: 100%;\r\n              cursor: pointer;\r\n              transition: .4s;\r\n\r\n              .fa-pencil {\r\n                font-size: 18px;\r\n              }\r\n\r\n              &:hover {\r\n                background: gray;\r\n              }\r\n            }\r\n          }\r\n\r\n          img {\r\n            width: 90%;\r\n            height: 130px;\r\n            object-fit: contain;\r\n          }\r\n\r\n        }\r\n\r\n        .card-body {\r\n          height: calc(250px - 150px - 1rem);\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: flex-end;\r\n          padding: 0;\r\n\r\n          .stakeholder-organization {\r\n            font-size: 1.1rem;\r\n            font-weight: 600;\r\n            text-transform: uppercase;\r\n          }\r\n        }\r\n\r\n        .card-footer {\r\n          background: transparent;\r\n          border-top: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
